import React, { HTMLAttributes } from 'react'
import { AnimatePresence } from 'framer-motion'

type AnimatePresenceWrapperProps = HTMLAttributes<'div'> & {
    children?: React.ReactNode;
};

export const AnimatePresenceWrapper: React.FC<AnimatePresenceWrapperProps> = ({ children, ...restProps }) => {
    return (
        <AnimatePresence {...restProps}>
            {children}
        </AnimatePresence>
    );
};
